import React from 'react';
import { isEmpty } from 'lodash';
import PipelineConnectors from '../../pipelines/PipelineConnectors';
import { WHITELABEL_SETTINGS } from 'js/constants/config';
import ImageLoader from '../../elements/icons/ImageLoader';
import { FlowNodes } from 'js/components/pipelines/FlowNodes';

const styles = {
  mainContent: {
    backgroundColor: `${WHITELABEL_SETTINGS.pipelines.bgColor}`,
  },
};

class FlowPreview extends React.Component {
  render() {
    const {
      height = 500,
      isDataFlowStatus,
      fitViewOptions,
      nodeKey,
      rootKey,
      excludeUpstream,
      pipelineEdges,
      pipelineItems,
      branches,
      treeHeight,
      connectionTypes,
      showFlow,
      onItemClick,
      scaleFactor,
      onRootRef,
      excludeFlowControlNode,
      isNodeDiscoveryEnabled,
    } = this.props;

    if (!showFlow) {
      return <ImageLoader />;
    }

    if (isEmpty(pipelineItems)) {
      return null;
    }

    return (
      <div className="view-source-pipeline" style={styles.mainContent} ref={onRootRef}>
        <div className="pipeline-container" style={{ transform: `scale(${scaleFactor})` }}>
          <PipelineConnectors
            id="preview-pipeline-connectors"
            edges={pipelineEdges}
            treeHeight={treeHeight}
          />
          <div className="pipeline-items-container" style={{ height }}>
            <FlowNodes
              id={nodeKey}
              pipelineItems={pipelineItems}
              fitViewOptions={fitViewOptions}
              disableHashing
              excludeFlowControlNode={excludeFlowControlNode}
              miniMapPosition="bottom-left"
              nodeProps={{
                nodeKeys: excludeUpstream ? [nodeKey] : [rootKey],
                branches: branches,
                select: () => {},
                isRoot: true,
                connectionTypes: connectionTypes,
                isPreview: true,
                isDataFlowStatus,
                onItemClick,
                isNodeDiscoveryEnabled,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default FlowPreview;
